import {
  Skeleton,
  StatusChip,
  tokens,
  Typography,
  Stack,
} from '@cast/design-system';

const sloChipSkeletonSx = {
  borderRadius: '4px',
  flexShrink: 0,
};

type SloCountChipProps = {
  count: number;
  tone: 'breach' | 'risk';
};

const CHIP_COLORS = {
  breach: {
    bg: tokens.theme.bg.status.errorSubtle,
    fg: tokens.theme.fg.status.onErrorSubtle,
  },
  risk: {
    bg: tokens.theme.bg.status.warningSubtle,
    fg: tokens.theme.fg.status.onWarningSubtle,
  },
} as const;

const SloCountChip = ({ count, tone }: SloCountChipProps) => (
  <StatusChip
    size="sm"
    sx={{
      bgcolor: CHIP_COLORS[tone].bg,
      color: CHIP_COLORS[tone].fg,
      minWidth: 28,
      justifyContent: 'center',
    }}
  >
    {count}
  </StatusChip>
);

type SloCellProps = {
  breachCount: number;
  riskCount: number;
};

export const SloCellSkeleton = () => (
  <Skeleton variant="rounded" width={28} height={20} sx={sloChipSkeletonSx} />
);

export const SloCell = ({ breachCount, riskCount }: SloCellProps) => {
  if (!breachCount && !riskCount) {
    return (
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.disabled.fg }}
        fontStyle="italic"
      >
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" alignItems="center" gap={4}>
      {breachCount > 0 ? (
        <SloCountChip count={breachCount} tone="breach" />
      ) : null}
      {riskCount > 0 ? <SloCountChip count={riskCount} tone="risk" /> : null}
    </Stack>
  );
};
